/**
 * 要求：基本配置
 */
(function (global, factory) {
    var theExports = null;
    var hasModuleExports = false;
    if(typeof module === 'object' && typeof module.exports === 'object') {
        theExports = module.exports;
        hasModuleExports = true;
    } else {//导出为模块
        theExports = global['App_Conf'] = {};
    }
    factory(theExports, hasModuleExports);
}(typeof window !== 'undefined' ? window : this, function (exports, hasModuleExports) {
    exports.__name__ = 'App_Conf';
    //
    if(hasModuleExports) {
        console.log('以模块方式导入[' + exports.__name__ + ']');
    }
    else {
        console.log('以普通方式导入[' + exports.__name__ + ']');
    }
    //---------------------------------------------------------------------------------
    let {Utils, Ajax, H5file} = require('./app.base');
    //---------------------------------------------------------------------------------

    // 当前模式
    const CUR_ENV = process.env.CUR_ENV;

    if(CUR_ENV === 'prd') {
        console.log('生产环境');
    } else if(CUR_ENV === 'dmo') {
        console.log('演示环境');
    } else if(CUR_ENV === 'tst') {
        console.log('测试环境');
    } else if(CUR_ENV === 'test') {
        console.log('本地测试');
    } else {
        console.log('开发环境');
    }

    // 设置rest api基本url
    if(typeof getRestUrl == 'function' && getRestUrl('') !== null) {
        Ajax.baseUrl(getRestUrl(''));
    } else if(typeof getAppUrl == 'function') {
        // 设置Ajax基本url
        Ajax.baseUrl(getAppUrl(''));
    }

    //设置fileUploader的baseurl
    if(typeof H5file == 'object' && H5file != null) {
        let FileUploader = H5file.Uploader;
        if(typeof getAppUrl == 'function') {
            FileUploader.baseUrl = getAppUrl('');
        }
    }

    // appBaseUrl => http://www.ushangupu.cn
    // appRelUrl => /goods?id=1
    // hashUrl => /spec/list?x=2
    // => http://www.ushangupu.cn/goods?id=1#/spec/list?x=2
    function makePageRouteUrl(appBaseUrl, appRelUrl, hashUrl) {
        appRelUrl = appRelUrl || '/';
        hashUrl = hashUrl || '';
        //
        let urlInfo = {
            appRelUrl: appRelUrl
        };
        if(hashUrl) {
            urlInfo.hashUrl = hashUrl;
        }
        //
        if(!appBaseUrl) {
            appBaseUrl = typeof getAppUrl == 'function' ? getAppUrl('') : '';
        }
        appBaseUrl += '/route';
        //
        return Utils.makeUrl(appBaseUrl, urlInfo, true);
    }

    //在页面中打开 => http://www.ushangupu.cn/goods?id=1#/spec/list?x=2
    // appBaseUrl => http://www.ushangupu.cn
    // appRelUrl => /goods?id=1
    // hashUrl => /spec/list?x=2
    // openPageRouteUrl(appBaseUrl, appRelUrl, hashUrl);
    function openPageRouteUrl(appBaseUrl, appRelUrl, hashUrl) {
        let pageRouteUrl = makePageRouteUrl(appBaseUrl, appRelUrl, hashUrl);
        Utils.setPageUrl(pageRouteUrl, '_blank');
    }

    /*在新窗口中打开文件md5码*/
    function showFileMd5(fileUuid, appBaseUrl = null) {
        if(appBaseUrl == null) {
            if(typeof getAppUrl == 'function') {
                appBaseUrl = getAppUrl('');
            }
        }
        var targetUrl = Utils.makeUrl(appBaseUrl + '/file/md5/info/jsp', {uuid: fileUuid});
        Utils.setPageUrl(targetUrl, '_blank');
    }

    /* 生成目标文本内容对应的二维码图片url（可直接设置到 <img src=... />上）*/
    function makeQrCodeImageUrl(content = '', width = 200, height = 200, appBaseUrl = null, attachInfo = null) {
        if(appBaseUrl && Utils.isPlainObject(appBaseUrl)) {//attachInfo 放在了 appBaseUrl的位置上
            attachInfo = appBaseUrl;
            appBaseUrl = null;
        }
        //
        if(appBaseUrl == null) {
            if(typeof getAppUrl == 'function') {
                appBaseUrl = getAppUrl('');
            }
        }
        let params = {
            content: content,
            width: width,
            height: height
        };
        if(attachInfo) {
            let headText = attachInfo['headText'];
            if(headText) {
                params['headText'] = headText;
            }
            let footText = attachInfo['footText'];
            if(footText) {
                params['footText'] = footText;
            }
            let headHeight = attachInfo['headHeight'];
            if(headHeight) {
                params['headHeight'] = headHeight;
            }
            let footHeight = attachInfo['footHeight'];
            if(footHeight) {
                params['footHeight'] = footHeight;
            }
        }
        return Utils.makeUrl(appBaseUrl + '/xutil/qrCode.do', params, true);
    }

    //------------------------------- 文件预览、查看 {{{ ---------------------------
    //判断是否为可按txt预览文档类型
    let __viewableTxtExtNames = ['.txt', '.xml', '.json', '.csv', '.xls', '.xlsx', '.ods'];

    function isViewableTxtType(fileName) {
        fileName = fileName || '';
        let dotExtName = Utils.extractFileNameExt(fileName).toLowerCase();
        return __viewableTxtExtNames.indexOf(dotExtName) != -1;
    }

    /** 生成文档txt预览url */
    function makeViewAsTxtUrl(uuid) {
        let theAbsUrl = getAppAbsUrl('/file/view/as/txt');
        return Utils.makeUrl(theAbsUrl, {
            uuid: uuid || null
        });
    }

    //判断是否为可按pdf预览文档类型
    let __viewablePdfExtNames = ['.pdf', '.doc', '.docx', '.rtf', '.ppt', '.pptx', '.odt', '.odp'];

    function isViewablePdfType(fileName) {
        fileName = fileName || '';
        let dotExtName = Utils.extractFileNameExt(fileName).toLowerCase();
        return __viewablePdfExtNames.indexOf(dotExtName) != -1;
    }

    /** 生成文档pdf预览url */
    function makeViewAsPdfUrl(uuid) {
        let theAbsUrl = getAppAbsUrl('/file/view/as/pdf');
        let appViewAsPdfUrl = Utils.makeUrl(theAbsUrl, {
            uuid: uuid || null
        });
        let pdfViewerUrl = getRescUrl('/lib/pdfjs/web/viewer.html');
        return Utils.makeUrl(pdfViewerUrl, {
            file: appViewAsPdfUrl
        }, true);
    }

    //txt + pdf
    let __viewableDocExtNames = __viewableTxtExtNames.concat(__viewablePdfExtNames);

    function isViewableDocType(fileName) {
        fileName = fileName || '';
        let dotExtName = Utils.extractFileNameExt(fileName).toLowerCase();
        return __viewableDocExtNames.indexOf(dotExtName) != -1;
    }

    function makeViewableDocUrl(fileName, uuid) {
        if(isViewablePdfType(fileName)) {
            return makeViewAsPdfUrl(uuid);
        }
        else if(isViewableTxtType(fileName)) {
            return makeViewAsTxtUrl(uuid);
        }
        return null;
    }

    //------------------------------- 文件预览、查看 }}} ---------------------------

    //默认分页的大小列表
    let __defaultPageSizes = [10, 50, 100, 200];

    function getDefaultPageSizes() {
        return __defaultPageSizes.clone();
    }

    //默认导出每文件最大条数
    let __defaultDownloadPageSize = 3000;

    function getDefaultDownloadPageSize() {
        return __defaultDownloadPageSize;
    }

    //百度地图app key
    let __bdMapAppKey = 'DjjgE6godux1wwMYhYh49jtH';
    //
    //----------------------------------- exports -------------------------------------
    exports.CUR_ENV = CUR_ENV;

    exports.makePageRouteUrl = makePageRouteUrl;

    exports.openPageRouteUrl = openPageRouteUrl;

    exports.makeQrCodeImageUrl = makeQrCodeImageUrl;

    exports.showFileMd5 = showFileMd5;

    //txt + pdf
    exports.isViewableDocType = isViewableDocType;
    exports.viewableDocExtNames = __viewableDocExtNames;
    exports.makeViewableDocUrl = makeViewableDocUrl;

    exports.getDefaultPageSizes = getDefaultPageSizes;

    exports.getDefaultDownloadPageSize = getDefaultDownloadPageSize;

    exports.bdMapAppKey = __bdMapAppKey;
}));



//////////////////
// WEBPACK FOOTER
// ./src/app.conf.js
// module id = 3
// module chunks = 0